// extracted by mini-css-extract-plugin
export var circle = "_45-2";
export var icon = "_45-a";
export var iconHighlight = "_45-0";
export var lg = "_45-8";
export var md = "_45-7";
export var outline = "_45-4";
export var sm = "_45-6";
export var square = "_45-1";
export var xl = "_45-9";
export var xs = "_45-5";
export var xxs = "_45-3";